import { Icon, IconButton, Td, Tr } from "@chakra-ui/react";
import { t } from "i18next";
import { Dispatch, SetStateAction, useState } from "react";
import { FaRegComments } from "react-icons/fa";
import { ReceivedBseBidDto, WinningProductGroupBidsDto } from "../../../../../autogen/bff-api";
import { Message } from "../../../../../common/ConversationModal";
import { ProductFieldCell } from "../../../../../common/products/ProductFieldCell";
import { Product, ProductDraft, ProductGroup } from "../../../../../common/types";
import { getAwardedProductPrice, getBestProductPrice } from "./BidEvaluationUtils";
import { SelectPriceCell } from "./SelectPriceCell";

export const EvaluationRow = ({
  product,
  group,
  bids,
  selectedBids,
  setProductConversation,
}: {
  product: Product;
  group: ProductGroup;
  bids?: ReceivedBseBidDto[];
  selectedBids: WinningProductGroupBidsDto[];
  setProductConversation: Dispatch<
    SetStateAction<
      | {
          conversation: Message[];
          title: string;
          productGroup: ProductGroup;
          product: Product | ProductDraft;
        }
      | undefined
    >
  >;
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const toggle = () => setIsExpanded((expanded) => !expanded);

  return (
    <Tr key={product.id}>
      {group.productFields
        .filter((field) => field.populatedBy === "Buyer")
        .map((field) => (
          <ProductFieldCell
            key={field.name}
            value={product.productFields.find((f) => f.name === field.name)?.value}
            isBoolean={field.type === "Boolean"}
            isExpanded={isExpanded}
            onToggle={toggle}
            fadeToColor="smBackground"
            minWidth="40"
            p="1"
          />
        ))}
      <Td minWidth="40" verticalAlign={"top"} p="4">
        {product.quantity.value}
      </Td>
      {bids?.map((bid) => (
        <SelectPriceCell
          key={bid.id}
          bid={bid}
          bids={bids}
          product={product as Product}
          group={group}
          selectedBids={selectedBids}
        />
      ))}
      {
        <Td textAlign={"right"} verticalAlign={"top"} p="4">
          {getBestProductPrice({
            productId: product.id,
            group,
            bids: bids ?? [],
          })?.toLocaleString()}
        </Td>
      }
      <Td textAlign={"right"} verticalAlign={"top"} fontWeight={"bold"} p="4">
        {getAwardedProductPrice({
          group,
          productId: product.id,
          bids: bids ?? [],
          selectedBids,
        })
          ? getAwardedProductPrice({
              group,
              productId: product.id,
              bids: bids ?? [],
              selectedBids,
            })?.toLocaleString()
          : ""}
      </Td>
      <Td verticalAlign={"top"} p="1">
        <IconButton
          variant={"outline"}
          aria-label="Product comments"
          icon={<Icon as={FaRegComments} />}
          onClick={() =>
            setProductConversation({
              conversation:
                product.conversation?.map((msg, i) => ({
                  id: `${i}`,
                  value: msg.comment,
                  createdBy: `${msg.createdBy?.firstName} ${msg.createdBy?.lastName}`,
                  createdAt: msg.createdAt,
                })) ?? [],
              title: `${t("Conversation regarding product")} - ${product.productFields[0].value}`,
              product,
              productGroup: group,
            })
          }
        />
      </Td>
    </Tr>
  );
};
